import * as yup from 'yup';

export const isValidEmail = (email: string): boolean => {
    try {
        yup.string().email().validateSync(email);
        return true;
    } catch (error) {
        return false;
    }
};
